export const en = {
  AanmeldFormulierIndienen: "Submit registration form",
  Achternaam: "Surname",
  AdresWijzigingDoorgeven: "Notify us of a change of address",
  AchternaamBewindvoerderCurator: "Surname of the administrator or curator",
  AndereVraagOfOpmerking: "Do you have any other questions or comments?",
  AutomatischeIncassoAanvragen: "Apply for a direct debit",
  AutomatischeIncassoStopzetten: "Do you want to cancel the direct debit?",
  BankrekeningnummerWijzigen: "Change bank account number",
  BestaatUit10DigitsTekst:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het veld moet 10 cijfers bevatten.",
  BetalingsregelingAanvragen: "Betalingsregeling facturen Wmo vanaf 2020",
  BerekeningEigenbijdrage: "Calculation obligatory excess",
  BerekeningVanMijnEigenBijdrage: "Calculation of my obligatory excess",
  BetalingsRegelingAantalTermijnen: "In hoeveel termijnen wilt u het openstaande bedrag betalen?",
  BetalingsRegelingAantalTermijnenInfoText: "Als wij vragen hebben hierover, nemen wij contact met u op.",
  BetalingsRegelingAantalTermijnenMinValue:
    "U heeft het invulveld 'In hoeveel termijnen wilt u het openstaande bedrag betalen?' niet juist ingevuld. Het aantal termijnen moet minstens 1 zijn.",
  BevestigingEmail: "Do you want to receive confirmation by email?",
  BewindvoerdersCuratorenContactFormulier: "Bewindvoerders en curatoren",
  BewindvoerdersOverigeRegelingenBestandenInfoText:
    "Voeg een kopie toe van het besluit van de rechter waaruit blijkt dat u als bewindvoerder of curator bent aangesteld.",
  Bericht: "Message",
  BsnValidationFactoryText:
    "You have not correctly filled in the '{{label}}' field. The citizen service number consists of 9 digits.",
  BurgerServiceNummerClient: "Burgerservicenummer (BSN) cliënt",
  BurgerServiceNummerToelichting:
    "Does your question/request relate to your personal CAK file? If so, please enter your citizen service number and date of birth. This will allow us to provide a better answer to your question and respond more quickly.",
  Bijlage: "Attachment",
  bijlagen: "attachments",
  Bijlagen: "Attachment(s)",
  BijlageFileIndicatorLabel: "Attachment",
  BijlageInfoText: "Max 5 attachments, max 5 MB per attachment",
  BijlageToevoegen: "Add attachment",
  BijlageToevoegenButton: "Add attachment",
  CakKenmerk: "Kenmerk CAK",
  CAKKenmerkInfoText: "Your CAK ID number, code or reference number from the letter, your case number.",
  ClientInCurateelEnBewindRegister: "Staat uw cliënt in het centraal curatele- en bewindregister?",
  Contactformulier: "Contact form",
  ContactFormulierFormulierStapMijnVraag: "My question",
  DateNotInFutureValidationFactoryText:
    "The field '{{label}}' was not filled in correctly. A date in the future is not allowed.",
  DateValidationFactoryValidationText: "You have not entered a correct date in the field '{{label}}'.",
  DeHeer: "De heer",
  DocumentenAanvragen: "Request a document",
  DocumentOfFormulierDigitaalOpsturen: "Send a document or form digitally",
  EenVraagStellen: "Ask a question",
  EenWijzigingDoorgeven: "Notify us of a change",
  EigenBijdrageAutomatischBetalen: "Pay obligatory excess automatically",
  EmailAdres: "Email address",
  EmailAdresInfoTxt: "We use this email address if we need to contact you about this message.",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "You can enter a maximum of {{aantal}} characters.",
  FileMaxSizeValidationText:
    "You have uploaded more than the maximum allowed file size in the input field '{{label}}', attachments may be a maximum of 5MB.",
  FileMaxSizeValidationTextAlternative:
    "'{{label}}' is larger than the maximum allowed file size, attachments can be a maximum of 5MB.",
  FileMaxNumberOfAttachmentsValidationText:
    "You have uploaded more than the permitted number of attachments in the field '{{label}}', you may upload a maximum of {{maxFiles}} {{bijlagen}}.",
  GeboorteDatum: "Date of birth (dd-mm-yyyy)",
  GeboorteDatumClient: "Geboortedatum cliënt (dd-mm-jjjj)",
  HeeftUAndereVragenOfOpmerkingen: "Heeft u andere vragen of opmerkingen?",
  Huisnummer: "Huisnummer",
  IetsAnders: "Something else",
  Inleiding: "Introduction",
  IntegerValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  IsDecimalValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  Ja: "Ja",
  KenmerkCAK: "CAK Reference",
  KenmerkCAKInfoTxt: "Your CAK ID number, code or reference number from the letter, your case number.",
  KenmerkCAKToelichting:
    "Does your question/request relate to your personal CAK file? If so, please enter your CAK reference and date of birth. This will allow us to provide a better answer to your question and respond more quickly.",
  KlachtenFormulier: "Klachtenformulier",
  KlachtFormulierStapMijnKlacht: "My complaint",
  KlachtFormulierStapInleiding: "Introduction",
  KlantnummerInfoTxt: "Het klantnummer vindt u op de factuur, rechts naast het blauwe blokje.",
  KopieVanBeschikkingOntvangen: "Wilt u een kopie van de beschikking ontvangen?",
  KopieVanBeschikkingJaar: "Van welk jaar wilt u de beschikking ontvangen?",
  Land: "Land",
  Mevrouw: "Mevrouw",
  MijnGegevens: "My Details",
  NaamClient: "Naam cliënt",
  NaamKantoor: "Naam kantoor",
  Nee: "Nee",
  OverzichtOpenstaandeFacturenOntvangen: "Wilt u een overzicht van de openstaande facturen ontvangen?",
  OpenstaandSaldoOpvragen: "Request outstanding balance",
  PlaatsNaam: "Plaatsnaam",
  Postcode: "Postcode",
  MeldingNoteerNummerVoorVerzending:
    "Make a note of the number that appears after sending. Please mention this number when you contact us with a question. This way we can help you better.",
  MeldingNoteerNummerNaVerzending:
    "Make a note of the number above. Please mention this number when you contact us with a question. This way we can help you better.",
  Omschrijving: "Omschrijving",
  OmschrijfUwVraag: "Describe your question",
  OmWelkeRegelingGaatHet: "Which scheme are you contacting us about?",
  OverWelkeRegelingGaatHet: "Which scheme are you contacting us about?",
  Regeling: "Regeling",
  RegelingOndersteuningVanuitWmo: "Support under the Social Support Act (Wmo)",
  RegelingZorgVanuitDeWlz: "Care under the Long-Term Care Act (Wlz)",
  RegelingZorgverzekeringEnBuitenland: "Health insurance outside the Netherlands",
  RegelingMedicijnenMeeOpReis: "Travelling abroad with medication",
  RegelingOnverzekerden: "Uninsured persons scheme",
  RegelingBetalingsachterstandZorgpremie: "Healthcare premium arrears scheme",
  RegelingGemoedsbezwaarden: "Conscientious objectors",
  RekeningnummerIBAN: "Rekeningnummer (IBAN)",
  RekeningnummerIBANAutomatischeIncassoStopzetten:
    "Voor welk rekeningnummer (IBAN) wilt u de automatische incasso stopzetten?",
  RekeningNummerDoorgeven: "Wilt u het rekeningnummer van uw cliënt doorgeven?",
  RekeningNummerDoorgevenInfoText:
    "Op dit rekeningnummer kunnen wij eventueel bedragen terugbetalen. Bijvoorbeeld bij een aanpassing van de eigen bijdrage.",
  Straatnaam: "Straatnaam",
  Telefoonnummer: "Telephone number",
  Toelichting: "Toelichting",
  UBent: "U bent",
  UBentProfessioneelBewindvoerderOfCurator: "Professioneel bewindvoerder of curator",
  UBentBewindvoerderOfCuratorVoorEenFamilielidOfBekende:
    "Bewindvoerder of curator voor een familielid of bekende",
  UBentWSNPBewindvoerderOfCuratorBijFaillissement: "WSNP-bewindvoerder of curator bij faillissement",
  VerplichtVeldIsNietIngevuldTijdensVerzenden: "Verplicht veld is niet ingevuld tijdens verzenden",
  Voorletters: "Initials",
  VoorlettersBewindvoerderCurator: "Voorletter(s) bewindvoerder of curator",
  VoorIemandAnders: "For someone else who is a customer of the CAK.",
  VoorMijzelf: "For myself. I am a customer of the CAK.",
  WaarGaatUwVraagOver: "What is the question about?",
  WatWiltUDoen: "What do you want to do?",
  WelkBedragMaximaalAflossen: "Welk bedrag kunt u per maand maximaal missen?",
  WiltUBetalingsRegelingAanvragenVoorClient: "Wilt u een betalingsregeling aanvragen?",
  WiltUNieuweClientAanmelden: "Wilt u een nieuwe cliënt aanmelden?",
  WSNPBewindvoerderOfCuratorBijFaillissement: "Bent u WSNP-bewindvoerder of curator bij faillissement?",
  ZorgVanuitDeWlz: "Zorg vanuit de Wlz",
  Post: "Letter",
  Email: "E-mail",
  AvgFormulier: "Avg form",
  AvgFormulierStapMijnRecht: "My request",
  AvgFormulierStapInleiding: "Preface",
  AvgRechtInzien: "I want to view my data",
  AvgRechtWijzigen: "I want to change my data",
  AvgRechtVerwijderen: "I want to delete my data",
  AvgRechtBeperken: "I want to restrict the processing of my data"
};
